import * as amplitude from '@amplitude/analytics-browser';
import { Identify } from '@amplitude/analytics-browser';

let initialized = false;

export function initAmplitude(): void {
  if (initialized) return;

  const API_KEY = process.env.AMPLITUDE_KEY;

  amplitude.init(API_KEY, {
    defaultTracking: {
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: true,
    },
    autocapture: true,
  });

  initialized = true;
}

/**
 * Identify user AFTER successful login
 */
export function identifyUser(user: { id: string; email?: string; name?: string; role?: string }): void {
  if (!user?.id) return;
  amplitude.setUserId(user.id);
  const identify = new Identify();
  identify.set('platform', 'APP');
  identify.set('env', process.env.NODE_ENV || 'local');
  if (user.email) identify.set('email', user.email);
  if (user.name) identify.set('name', user.name);
  if (user.role) identify.set('role', user.role);

  amplitude.identify(identify);
}

export function track(eventName: string, props: Record<string, any> = {}) {
  return amplitude.track(eventName, {
    app_env: 'local',
    path: typeof window !== 'undefined' ? window.location.pathname : undefined,
    ...props,
  });
}

export function resetUser(): void {
  amplitude.setUserId(null);
  amplitude.reset();
}
